module.exports = __webpack_public_path__ + "static/empty-state-value-props-paragraph-dont-f769ecb28038d2f998bba5be0bcc1b54.png";